<template>
    <v-modal
        v-bind="{...$props, ...$attrs}"
        @before-open="$emit('before-open', $event)"
        @opened="$emit('opened', $event)"
        @before-close="$emit('before-close', $event)"
        @closed="$emit('closed', $event)"
        :style="cssProps"
    >
        <slot></slot>
    </v-modal>
</template>

<script>
    import Modal from './Modal';
    export default {
        components: {
            'v-modal': Modal
        },
        props: {
            name: {
                required: true,
                type: String,
            },
            height: {
                required: false,
                default() {
                    return '100%';
                }
            },
            scrollable: {
                required: false,
                type: Boolean,
                default() {
                    return false;
                }
            },
            width: {
                required: false,
                default() {
                    return '100%';
                }
            },
            showCloseIcon: {
                required: false,
                type: Boolean,
                default() {
                    return true;
                },
            },
            shiftX: {
                required: false,
                type: Number,
                default() {
                    return 1;
                },
            },
            shiftY: {
                required: false,
                type: Number,
                default() {
                    return 0;
                },
            },
            classes: {
                required: false,
                type: String,
                default() {
                    return 'right-panel-modal !rounded-none';
                }
            },
            transition: {
                required: false,
                type: String,
                default() {
                    return 'right-panel-modal_transition';
                }
            },
            contentClasses: {
                required: false,
                type: String,
                default() {
                    return this.$spa.css.modal.right_panel.content;
                }
            },
            rightPanelWidth: {
                type: String,
                default: '700px'
            },
            rightPanelWidthXl: {
                type: String,
                default: '850px'
            }
        },
        computed: {
            cssProps() {
                return {
                    '--right-panel-width': this.rightPanelWidth,
                    '--right-panel-width-xl': this.rightPanelWidthXl,
                }
            }
        }
    }
</script>


<style>
    .right-panel-modal_transition-enter-active, .right-panel-modal_transition-leave-active {
        transition-property: transform, opacity;
        transition-duration: 150ms;
        transition-timing-function: ease-out;
    }
    .right-panel-modal_transition-enter, .right-panel-modal_transition-leave-to {
        transform: translateX(0);
        opacity: 0;
    }
    .right-panel-modal_transition-leave, .right-panel-modal_transition-enter-to {
        transform: translateX(0);
        opacity: 100;
    }

    .right-panel-modal {
        width: 100% !important;
        max-width: 100% !important;
        border-radius: 0 !important;
        top: 0 !important;
        bottom: 0 !important;
        right: 0 !important;
        left: 0 !important;
        height: 100% !important;
    }

    @screen md {
        .right-panel-modal {
            width: var(--right-panel-width) !important;
            left: calc(100% - var(--right-panel-width)) !important;
            border-radius: 5px!important;
        }
        .right-panel-modal_transition-enter, .right-panel-modal_transition-leave-to {
            transform: translateX(1rem);
            opacity: 0;
        }
    }

    @screen xl {
        .right-panel-modal {
            width: var(--right-panel-width-xl) !important;
            left: calc(100% - var(--right-panel-width-xl)) !important;
        }
    }
</style>